import React from "react";
import "./index.css";
export default function ({ isSmall, onChange, value, selected }) {
  return (
    <label id={`${isSmall ? "small_switch" : null}`} className="switch">
      <input
        type="checkbox"
        onChange={onChange}
        id={value}
        checked={value == selected}
      />
      <span className="slider round"></span>
    </label>
  );
}


